export default __webpack_public_path__ + "static/background-bfb9087202b88eac3ae470f870b700d2.png";